/**
 * Check if WebGL is available in the current browser
 * @returns true if WebGL is supported, false otherwise
 */
export const isWebGLAvailable = (): boolean => {
	try {
		const canvas = document.createElement('canvas');
		return !!(
			window.WebGLRenderingContext &&
			(canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
		);
	} catch (e) {
		return false;
	}
};
